import { css } from 'lit';
export default css `
  wui-icon-link[data-hidden='true'] {
    opacity: 0 !important;
    pointer-events: none;
  }
`;
//# sourceMappingURL=styles.js.map